import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20football%20stadium%20panorama%20with%20warm%20sunset%20lighting%2C%20dramatic%20sky%20with%20golden%20and%20crimson%20clouds%2C%20empty%20green%20pitch%2C%20atmospheric%20and%20heroic%20mood%2C%20cinematic%20sports%20photography%2C%20epic%20scale&width=1800&height=600&seq=cta-football&orientation=landscape"
        alt="深入了解郝海东的传奇故事"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-900/70 to-primary-900/90"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          深入了解郝海东的传奇故事
        </h2>
        <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-8">
          浏览更多关于郝海东的进球纪录、国家队生涯、俱乐部岁月和争议事件的深度文章。
        </p>
        <Link
          to="/category/goals"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap"
        >
          <span>浏览全部文章</span>
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}